<template>
<div class="container-fluid">

<div v-if="modalSpinner.show">

  <modal-spinner v-if="modalSpinner.show==true" @close="setModalSpinner(false)" v-bind:props="modalSpinner"></modal-spinner>
  
</div>
<div v-else>
<div class="card border-primary" >
  <div class="card-header bg-primary text-white">
    <h4><i style="color:#FFCC00" class="far fa-list-alt mr-3"></i>
    LISTA DOCUMENTI FORNITORI</h4>
  </div>
  <div class="card-body text-primary">
    <div class="row">
   

    <div class="col">
    <div class="table-wrapper-scroll-y my-custom-scrollbar ">              
  <table class="table table-sm table-hover  mb-0" id="table">
    <thead >
      <tr class="table-primary">
        <th>
         # 
        </th>  
        <th>
         FORNITORE
        </th>  
        <th class="text-right text-nowrap">
        TOTALE Q.TA'
        </th>
        <th class="text-right text-nowrap">
        TOTALE €
        </th>
        <th class="text-nowrap">
        DATA MOVIMENTO
        </th>  
        
        <th>
         TIPO
        </th>    
        <th class="text-nowrap">
        NUMERO DOCUMENTO
        </th>
        <th class="text-nowrap">
        DATA DOCUMENTO
        </th>
        <th>
        SEDE
        </th>
    
        
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in filteredItems" :key="index">
        <td>
          {{index+1}}
        </td>
        
        <td class="text-nowrap">
          {{item.supplier}}
        </td>
        <td class="text-right text-nowrap">
            {{fmt2(item.total_qty)}}
        </td>
        <td class="text-right text-nowrap">
            {{fmt1(item.total_value)}}
        </td>
        <td>
          {{item.create_at}}
        </td>
        
        <td class="text-nowrap">
            {{item.description}}
        </td>
          
        <td>
         {{item.number}}
        </td>
        <td>
         {{item.date}}  
        </td>
        <td class="text-nowrap">
            {{item.store}}
        </td>
      
        

        
    
      </tr>
    </tbody>
  </table> 
 </div>
</div>

</div>
  <label for="cerca">
  <i style="color:navy" class="fas fa-filter mr-2" aria-hidden="true"></i>  
  <strong>Filtra</strong></label>
  <input class="form-control" type="text" name="query" v-model="filterKey">
 

    
  </div>
</div>


</div>
</div>


</template>

<script>
import api                from '@/api';
import { mapGetters }     from 'vuex';




import modalSpinner       from '@/components/common/ModalSpinner.vue'
import fmt                from '@/components/mixins/fmt.js'

export default {
  mixins:[fmt], 
  

   components: {
     modalSpinner
   
  },
  
  data () {
    return {
      modalSpinner : {spinner:false,show:false},
    alert          : false, 
   

    items          : [],
   
    filterKey      : '',

    }
  },
  computed: 
  {  
    ...mapGetters(['company']),
    filteredItems : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
     

  },
  watch: 
  {
    
  },
      
  mounted()
  {
  

    this.getData()

  },
  created()  
  {

    
  }, 
  methods: 
    {
      setModalSpinner(show)
      {
        

        this.modalSpinner.show = show
        
      },
      async getData() 
      {
        
        this.modalSpinner.show    = true
        this.modalSpinner.spinner = true
        this.modalSpinner.title   = 'Caricamento documenti in corso ...'
        const data  = {'companyId' : this.company.Id}
        const sp = {'sp'           : 'spSupplierAllDocuments'}
        
        const json    = Object.assign(data, sp)

        
        await api.post(json).then(res => {
          
        

          if(res.status==200)
            {
              this.modalSpinner.show = false 
               this.items = res.data.recordsets[0]   

               
            }
           else if(res.status==500)
           {
              
              this.modalSpinner.spinner = false            
              this.modalSpinner.msg = res.data
              
                
                    
           } 
           else
            {
                            
              this.modalSpinner.spinner = false            
              this.modalSpinner.msg = res
                 
            } 
          

          }).catch(err => {
              
              this.modalSpinner.spinner = false            
              this.modalSpinner.msg = err.message
              
              
          }).finally(() => {
          
        });


      }
    },
    
}
</script>

<style scoped>
h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
p{
  font-family: 'Roboto Condensed';
  font-size: 25px;
}
.my-custom-scrollbar {
position : relative;
height   : 600px;
overflow : auto;
}
.table-wrapper-scroll-y {
display  : block;
}
.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;
    height       : 40px;

 }
a,th{
  font-family : 'Roboto Condensed';
  font-size   : 15px;
 
}

input[type='checkbox'] {
 
  cursor         : pointer;
 
}
.table th:first-child
{
  border-radius : 0 0 0 8px;
}
.table th:last-child
{
  border-radius : 0 8px 0 0;  
}
.card-header
{
  height: 45px;
}

</style>